/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './aeration-details.scss';

/* eslint-disable import/no-unresolved, import/default */

import aerationDetailsTemplate from './aeration-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.aerationDetails', [])
    .directive('agAerationDetails', AerationDetails)
    .name;

/*@ngInject*/
function AerationDetails() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AerationDetailsController,
        controllerAs: 'vm',
        templateUrl: aerationDetailsTemplate
    };
}

/*@ngInject*/
function AerationDetailsController($scope, $log, $translate, agUtils, agTypes, types, aerationService, userService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;

    vm.latestValuesSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: function(subscription) {
                vm.loading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.aerationId = null;
    vm.aeration = null;
    vm.stateValue = stateValue;

    vm.stateSettings = {
        yaxis: {
            min: 0,
            max: 1.25
        }
    };

    vm.stateKeySettings = {
        showLines: true,
        fillLines: true,
        axisTicksFormatter: `if (value >= 0 && value <=1 ) { 
                                return value < 1 ? '${$translate.instant('ag.aeration.off')+''}' : '${$translate.instant('ag.aeration.on')+''}'; 
                             } else {
                                return '';
                             };`,
        tooltipValueFormatter: `return value == 1 ? '${$translate.instant('ag.aeration.on')+''}' : '${$translate.instant('ag.aeration.off')+''}';`
    };

    vm.getIcon = () => {
        if (!vm.aeration) return undefined
        return agUtils.getAssetIcon(vm.aeration.aerationType, vm.aeration.highestAlarmSeverity, vm.aeration.highestAlarmStatus)
    }

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [];
            vm.ctx.hideTitlePanel = false;

            vm.aerationId = null;
            if (vm.ctx.stateController) {
                vm.aerationId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadAeration();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newAerationId, prevAerationId) {
                    if (newAerationId && !angular.equals(newAerationId, prevAerationId)) {
                        vm.aerationId = newAerationId;
                        loadAeration();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.aeration ? (vm.aeration.label || vm.aeration.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function loadAeration() {
        vm.aeration = null;
        reset();
        if (vm.aerationId) {
            vm.loading = true;
            aerationService.getAeration(vm.aerationId).then(
                function success(aeration) {
                    vm.aeration = aeration;
                    var latestValuesSubscriptionsInfo = [{
                        type: types.datasourceType.entity,
                        entityType: types.entityType.asset,
                        entityId: vm.aeration.id.id,
                        entityName: vm.aeration.name,
                        timeseries: [
                            {name: vm.agTypes.telemetry.aeration.state}
                        ]
                    }];
                    vm.ctx.subscriptionApi.createSubscriptionFromInfo (
                        types.widgetType.latest.value, latestValuesSubscriptionsInfo, vm.latestValuesSubscriptionOptions, false, true).then(
                        function(subscription) {
                            vm.latestValuesSubscription = subscription;
                        }
                    );

                    vm.aerationStateHistorySubscriptionsInfo = [{
                        type: types.datasourceType.entity,
                        entityType: types.entityType.asset,
                        entityId: vm.aeration.id.id,
                        entityName: vm.aeration.name,
                        timeseries: [
                            {
                                name: agTypes.telemetry.aeration.state,
                                label: $translate.instant('ag.aeration.state'),
                                color: agTypes.colors.normalColor,
                                postFuncBody: "return value == 'on' ? 1 : 0;"
                            }
                        ]
                    }];
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function stateValue(state) {
        if (state === 'on') {
            return $translate.instant('ag.aeration.on');
        } else if (state === 'off') {
            return $translate.instant('ag.aeration.off');
        } else {
            return '';
        }
    }

    function reset() {
        if (vm.latestValuesSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
        }
        resetValues();
    }

    function resetValues() {
        vm.currentState = '';
    }

    function onDataUpdated(subscription, apply) {
        var data = subscription.data;
        for (var i=0;i<data.length;i++) {
            var datasourceData = data[i];
            var val = getValue(datasourceData);
            switch (datasourceData.dataKey.name) {
                case vm.agTypes.telemetry.aeration.state:
                    vm.currentState = val;
                    break;
            }
        }
        if (apply) {
            $scope.$digest();
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    function getValue(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][1])) {
            return keyData.data[0][1];
        } else {
            return '';
        }
    }
}